import { Animated } from 'react-native';

export default class AnimatedValueSubscription {
  constructor(value, callback) {
    this._value = value;
    this._token = value.addListener(callback);
  }

  remove() {
    this._value.removeListener(this._token);
  }
}



// WEBPACK FOOTER //
// ./node_modules/react-navigation/src/views/AnimatedValueSubscription.js